<script setup lang="ts">
import AppStoreLogo from '../vectors/AppStoreLogo.vue';
import GooglePlayLogo from '../vectors/GooglePlayLogo.vue';
import ItemMenu from '../list-item/ItemMenu.vue';

const ITEMS = [
  { label: 'App Store', href: 'https://apps.apple.com/cz/app/mixit/id6444029029', logo: AppStoreLogo },
  { label: 'Google Play', href: 'https://play.google.com/store/apps/details?id=cz.mixit.app', logo: GooglePlayLogo },
];
</script>

<template>
  <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden w-70">
    <template
      v-for="(item, index) in ITEMS"
      :key="index"
    >
      <ItemMenu
        :label="item.label"
        :router-to="item.href"
      >
        <template #icon>
          <component
            :is="item.logo"
            class="shrink-0 w-4.5"
          />
        </template>
      </ItemMenu>
      <hr
        v-if="index < ITEMS.length - 1"
        class="border-brown-100"
      >
    </template>
  </div>
</template>
